import { SvgIcon, SvgIconProps } from '@mui/material';

export const CategoryIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
        className='icon icon-cat icons-cat-outline icon-cat-category-2'
      >
        <path stroke='none' d='M0 0h24v24H0z' fill='none' />
        <path d='M14 4h6v6h-6z' />
        <path d='M4 14h6v6h-6z' />
        <path d='M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0' />
        <path d='M7 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0' />
      </svg>
    </SvgIcon>
  );
};
